export interface QuizModalProps {
  quizId: string;
  entityId: string;
  entityType: QuizEntityType;
  onClose: (result?: QuizResult) => void;
}

export interface QuizResult {
  isComplete: boolean;
  vacancyEmail: string | undefined;
  correctAnswers?: string[];
}

export interface Quiz {
  id: string;
  name: string;
  questions: Question[];
}

export interface Question {
  id: string;
  questionText: string;
  type: QuestionType;
  answers: Answer[];
}

export interface Answer {
  id: string;
  answerText: string;
  isCorrect: boolean;
}

export interface QuestionAnswers {
  questionId: string;
  answerIds: string[];
}

export enum QuestionType {
  Open = 1,
  SingleAnswer = 2,
  MultipleAnswer = 3,
  ImageSelection = 4
}

export enum QuizEntityType {
  Work = 0,
  KnowledgeBase = 1
}

export interface BaseInfo {
  Start: JSX.Element;
  Congrats: JSX.Element;
  TryAgain: JSX.Element;
  Exit: JSX.Element;
}

export const WorkInfoTypes: BaseInfo = {
  Start: (
    <>
      <h2>До відома претендентів</h2>
      <p>
        Для того, щоб мати можливість подати свою кандидатуру на вакансію необхідно пройти тестування. Після успішного
        завершення тестування буде надана контактна електронна пошта, на яку необхідно надіслати резюме та додати назву
        вакансії в темі.
      </p>
    </>
  ),
  Congrats: (
    <>
      <h2>Ти успішно пройшов тестування!</h2>
      <p>
        Вам відкрилися контактні дані підрозділу для подачі на вакансію. Зверни увагу, що контактні дані підрозділу
        будуть доступні протягом обмеженого часу. Рекомендуємо відгукнутись на ваканію одразу або зберегти дані на твій
        пристрій.
      </p>
    </>
  ),
  TryAgain: (
    <>
      <h2>Нам потрібен трохи вищий результат</h2>
      <p>
        На жаль тобі не вдалось успішно пройти тест. Ти можеш пройти його повторно через 15хв. Використай цей час для
        покращення знань.
      </p>
    </>
  ),
  Exit: (
    <>
      <h2>Чи ви дійсно хочете вийти з опитування?</h2>
      <p>
        Якщо ви перервете опитування зараз, ваші відповіді не будуть збережені, і наступного разу вам доведеться
        проходити опитування з початку.
      </p>
    </>
  )
};

export const KBInfoTypes: BaseInfo = {
  Start: (
    <>
      <h2>До відома </h2>
      <p>
        Ви маєте можливість перевірити отриманні знання шляхом проходження тестування.
        <br /> Вказане тестування є пробним та не створює будь-яких наслідків. Питання можуть бути включені до
        тестувань, передбачених для кандидатів на вакансії у підрозділах ЦВС. Успіхів!
      </p>
    </>
  ),
  Congrats: (
    <>
      <h2>Вітаю, ти успішно пройшов тестування!</h2>
      <p>Так тримати, ти гарно засвоїв вивчений матеріал і можеш переходити до наступного розділу.</p>
    </>
  ),
  TryAgain: (
    <>
      <h2>Нажаль, не усі відповіді виявились вірними</h2>
      <p>Ти маєш можливість повторно пройти тестування, а також перевірити, які з відповідей надано не вірно</p>
    </>
  ),
  Exit: (
    <>
      <h2>Чи ви дійсно хочете вийти з опитування?</h2>
      <p>
        Якщо ви перервете опитування зараз, ваші відповіді не будуть збережені, і наступного разу вам доведеться
        проходити опитування з початку.
      </p>
    </>
  )
};

export const ModalTypes = (type: QuizEntityType) => (type === QuizEntityType.Work ? WorkInfoTypes : KBInfoTypes);
